import { render, staticRenderFns } from "./StaticError.vue?vue&type=template&id=34386528&"
import script from "./StaticError.vue?vue&type=script&lang=ts&"
export * from "./StaticError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports